// BULK UNLOCK ************************************************************************************
// pathname: /v1/job-operation/{jobSlug}/bulk-unlock
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';
import { PostBulkUnlockObject } from '@type/v1-api-types';

/**
 * @description Bulk unlock selected applicants for a job.
 *
 * @param jobSlug - the job slug
 * @param locale - the locale
 * @param onSuccess - callback function to be executed on success
 * @param onError - callback function to be executed on error
 *
 * @example
 * const { trigger, isMutating } = useSwrBulkUnlock({ jobSlug: 'job-slug', locale: 'ro' });
 * trigger();
 */
export const useSwrBulkUnlock = (props: {
  jobSlug: string;
  locale?: string;
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const {
    jobSlug,
    locale = 'ro',
    onSuccess,
    onError,
  } = props;

  const {
    data,
    error,
    trigger,
    isMutating,
    reset,
  } = useSwrMutationApi<unknown, PostBulkUnlockObject>({
    url: `/v1/job-operation/${jobSlug}/bulk-unlock`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: () => {
        if (onError) onError();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
